export enum MyContentItemAction {
  GoToPublicContentPage = 'GoToPublicContentPage',
  WriteEpisode = 'WriteEpisode',
  EditMyContent = 'EditMyContent',
  DeleteMyContent = 'DeleteMyContent',
  WithDrawContest = 'WithDrawContest',
  TurnToNormalContent = 'TurnToNormalContent',
}

export const MyContentItemActionText = {
  [MyContentItemAction.GoToPublicContentPage]: '게시된 작품 보러 가기',
  [MyContentItemAction.WriteEpisode]: '글쓰기',
  [MyContentItemAction.EditMyContent]: '작품 정보 수정',
  [MyContentItemAction.DeleteMyContent]: '작품 삭제',
  [MyContentItemAction.WithDrawContest]: '픽앤츄 접수 철회',
  [MyContentItemAction.TurnToNormalContent]: '일반 작품으로 전환하기',
};

export enum MyContentEpisodesItemAction {
  DeleteMyEpisode = 'DeleteMyEpisode',
  DeleteMyNotice = 'DeleteMyNotice',
}

export const MyContentEpisodesItemActionText = {
  [MyContentEpisodesItemAction.DeleteMyEpisode]: '회차 삭제',
  [MyContentEpisodesItemAction.DeleteMyNotice]: '공지 삭제',
};
